import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { CoBrowsingCompanyListDto } from '../../../dtos/co-browsing.dto';
import { CO_BROWSING_COMPANY_AUTO_SUGGESTION } from '../../../graphql';

@Injectable({ providedIn: 'root' })
export class CoBrowsingCompanyListService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getCompanySuggestions(
    searchText: string,
  ): Observable<CoBrowsingCompanyListDto> {
    const fieldName =
      getQueryRootFieldName(CO_BROWSING_COMPANY_AUTO_SUGGESTION) ||
      'companyLookup';

    return this.apollo
      .use(this.clientName)
      .query({
        query: CO_BROWSING_COMPANY_AUTO_SUGGESTION,
        variables: {
          searchText,
        },
        context: {
          headers: new HttpHeaders().set('SKIP_LOADING', 'true'),
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data.companyLookup),
      );
  }
}
